import React from 'react';
import {useTranslation} from 'react-i18next';

const FilterTeamHeader = () => {
	const {t} = useTranslation();
	return (
		<div className="filter-team__columns-top filter-team__columns">
			<span className="filter-team__item-top filter-team-top__filter-span-1">
				{' '}
			</span>
			<span className="filter-team__item-top filter-team-top__line">
				{t('Лінія')}
			</span>
			<span className="filter-team__item-top filter-team-top__name">
				{t('Прізвище, ім’я')}
			</span>
			<span className="filter-team__item-top filter-team-top__id">
				{t('Номер контракту')}
			</span>
			<span
				className="filter-team__item-top filter-team-top__om"
				title={t("к/бп - клієнт / бізнес партнер")}
			>
				{t('к/бп')}
			</span>
			<span className="filter-team__item-top filter-team-top__registration">
				{t('Дата Реєстрації')}
			</span>
			<span className="filter-team__item-top filter-team-top__qualification">
				{t('Квал')}
			</span>
			<span
				className="filter-team__item-top filter-team-top__oo"
				title={t("О/О - особистий об'єм в балах")}
			>
				{t('О/О')}
			</span>
			<span
				className="filter-team__item-top filter-team-top__mo"
				title={t("К/О - командний об'єм в балах")}
			>
				{t('к/о')}
			</span>
			<span className="filter-team__item-top filter-team-top__city">
				{t('Місто')}
			</span>
			<span className="filter-team__item-top filter-team-top__contact">
				{t('Контакт')}
			</span>
		</div>
	);
};

export default FilterTeamHeader;
